import {ECustomerOrganizationStatus, ECustomerUpdateStatus} from '@app/shared/enums/header.enum';
import {ICustomerInfo, ICustomerOrganization, ICustomerProfileState} from '@app/shared/models/header.model';
import {createAction, props} from '@ngrx/store';

export enum HeaderActions {
  GetCustomerProfile = '[Header Component] Get Customer Profile',
  GetCustomerProfileFromInstitutionSettingEffect = '[Institution Setting Effect] Get Customer Profile from institution setting effect',
  GetCustomerProfileSuccess = '[Header Effect] Get Customer Profile Success',
  GetCustomerProfileFailure = '[Header Effect] Get Customer Profile Failure',
  SetCustomerOrganizationStatus = '[Header Component] Set Customer Organization Account Status',
  SetCustomerOrganizationStatusFromHeaderEffect = '[Header Effect] Set Customer Organization Account Status',
  SetCustomerOrganization = '[Header Component] Set Customer Organization',
  SaveCustomerOrganizationSuccess = '[Header Effect] Save Customer Organization Success',
  LoadCustomerOrganization = '[Header Component] Load Customer Organization',
  LoadCustomerOrganizationSuccess = '[Header Effect] Load Customer Organization Success',
  OnChangeCustomerOrganization = '[Header Component] On Change Customer Organization',
  UpdateCustomerProfile = '[Profile Component] Update Customer Profile',
  SetUpdateCustomerProfileSuccess = '[Header Effect] Set Update Customer Profile Success',
  SetUpdateCustomerProfileFailure = '[Header Effect] Set Update Customer Profile Failure',
  ResetUpdateCustomerProfileStatus = '[Header Effect] Reset Update Customer Profile Status',
  LoadOrdersOnOrganizationChange = '[Header Component] Load orders on organization change',
}
export const getCustomerProfile = createAction(HeaderActions.GetCustomerProfile);

export const getCustomerProfileFromInstitutionSettingEffect = createAction(
  HeaderActions.GetCustomerProfileFromInstitutionSettingEffect
);

export const getCustomerProfileSuccess = createAction(
  HeaderActions.GetCustomerProfileSuccess,
  props<{customerProfileState: ICustomerProfileState}>()
);

export const getCustomerProfileFailure = createAction(HeaderActions.GetCustomerProfileFailure);

export const setCustomerOrganizationStatus = createAction(
  HeaderActions.SetCustomerOrganizationStatus,
  props<{accountStatus: ECustomerOrganizationStatus}>()
);

export const setCustomerOrganizationStatusFromHeaderEffect = createAction(
  HeaderActions.SetCustomerOrganizationStatusFromHeaderEffect,
  props<{accountStatus: ECustomerOrganizationStatus}>()
);

export const setCustomerOrganization = createAction(
  HeaderActions.SetCustomerOrganization,
  props<{organization: ICustomerOrganization}>()
);

export const updateCustomerProfile = createAction(
  HeaderActions.UpdateCustomerProfile,
  props<{customerProfile: ICustomerInfo}>()
);

export const setUpdateCustomerProfileSuccess = createAction(
  HeaderActions.SetUpdateCustomerProfileSuccess,
  props<{
    customerProfileState: ICustomerProfileState;
    updateCustomerStatus: ECustomerUpdateStatus;
  }>()
);

export const setUpdateCustomerProfileFailure = createAction(
  HeaderActions.SetUpdateCustomerProfileFailure,
  props<{
    updateCustomerStatus: ECustomerUpdateStatus;
  }>()
);

export const loadOrdersOnOrganizationChange = createAction(
  HeaderActions.LoadOrdersOnOrganizationChange,
  props<{isOrganizationChanged: boolean}>()
);

export const saveCustomerOrganizationSuccess = createAction(HeaderActions.SaveCustomerOrganizationSuccess);

export const loadCustomerOrganization = createAction(HeaderActions.LoadCustomerOrganization);

export const loadCustomerOrganizationSuccess = createAction(
  HeaderActions.LoadCustomerOrganizationSuccess,
  props<{organization: ICustomerOrganization}>()
);

export const onChangeCustomerOrganization = createAction(
  HeaderActions.OnChangeCustomerOrganization,
  props<{organization: ICustomerOrganization}>()
);

export const resetUpdateCustomerProfileStatus = createAction(HeaderActions.ResetUpdateCustomerProfileStatus);
